import VGToast from "../../../../../../../modules/vegas/js/toast";

class VGCatalog {
	popup(text, params = {}) {
		VGToast.init({
			autohide: true,
			theme: 'success',
			text: {
				header: '',
				body: text,
			}
		});
	}
}

export default VGCatalog;
